import create from "zustand";

const GlobalStore = create((set,get) => ({

    userLoginDetails: { },

    deliveryDetails: { },

    setUserLoginDetails: (userLoginDetails) => set(() => ({ userLoginDetails: userLoginDetails })),
    setDeliveryDetails: (deliveryDetails) => set(() => ({ deliveryDetails: deliveryDetails })),


    getUserLoginDetails: () => get().userLoginDetails,
    getDeliveryDetails: () => get().deliveryDetails
}))

export {GlobalStore}